'use strict';
//Jquery
//import $ from "jquery";
// jquery importuojamas globaliai webpack

//Bootstrap
//import Bootstrap from 'bootstrap';
//import "bootstrap/dist/css/bootstrap.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";

//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";

import { Fancybox } from "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

import select2 from 'select2';
import "select2/dist/css/select2.css";

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_lt';

import '../lib/jquery-nicefileinput/jquery.nicefileinput.js';
import '../lib/javascript-equal-height-responsive-rows/grids.js';

import { globalJsTranslations } from '../services/globaljstranslations.js';
import { hashController } from '../controllers/hashcontroller.js';

window.$ = $;

$(document).ready(function(){
	if (!$("#popup_window").length) { // init if not in dialog view
		select2init();
		fancybox();
		validate();
		owl_carousel();
		mobile_sidebar();
		fixed_header();
		eu_cookie();
		print_v();
		highlight_search_results();
		file_input();
		iframe_adaptability();
		reportbug_form();
		show_more();
		postformwidget_validate();
		init_contacts();
		login_tabs();
	}
});

$(window).on('load', function () {
	if ($(window).width() < 768){
		mobile_overflow_tables();
	}
});

function select2init() {
	$("select").select2({
		"minimumResultsForSearch": -1
	});

	// use this class if placeholder is needed. 
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}


function owl_carousel() {
	// Owl carousel 2 docs:
	//https://owlcarousel2.github.io/OwlCarousel2/docs/api-options.html
	
	if ($("#title_slides").length){
		$("#title_slides").owlCarousel({
			loop:true,
			margin:10,
			nav:false,
			items: 1,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			smartSpeed:150,
			mouseDrag: false
		 });
	}
}

function fancybox(){
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/
	
	// News preview
	$("a.news_image").fancybox({
		btnTpl: {
			zoom: false
		}
	});
	
	// News gallery 
	$("a[rel=fancybox_newsgallery]").fancybox({
		thumbs: false,
		transitionEffect: "slide",
		clickContent : false,
		btnTpl: {
			zoom: false
		}
	});
	
	// From Tinymce
	$("a[rel=fancybox]").fancybox({
		btnTpl: {
			zoom: false
		}
	});
	
	// Ajax call
	$("a.fancybox_ajax").fancybox({
		type: "ajax",
		touch: false // disable drag cursor
	});
	
	// Iframe call
	$("a.fancybox_iframe").fancybox({
		type: "iframe",
		touch: false // disable drag cursor
	});
}

function gallery_popup(){
	$('.gallery_popup').on("click", function () {
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");  
		$.ajax({
		  url: url,
		  type:"json",
		  success:function(data) {
			$(".album_loading").fadeOut("fast");
			var photos = [];
			$.each(data.photos, function(i){
				var obj = { 
					"src": this.img_itemimage,
					"thumb": this.img_itemimage_thumb
				};
				if (this.title){
					obj.subHtml= '<div class="photo_title">'+this.title+'</div>';
				}
				photos.push(obj);
			});		
			$this.lightGallery({
				dynamic: true,
				dynamicEl: photos,
				speed: 300,
				hideBarsDelay: 1000,
				closable : false,
				loop: false,
				download: false,
				enableDrag : false,
				thumbWidth : 112,
				thumbContHeight : 83,
				thumbMargin : 10,
				toogleThumb : false,
				galleryId : $this.data("id")
			});
			$this.on('onAfterOpen.lg',function(event, index, fromTouch, fromThumb){
				$(".lg").append("<div class='album_title lg-toolbar'><div class='album_title_text'>"+data.title+"</div></div>")
			});
		  },
		  error: function(){
			$(".album_loading").fadeOut("fast");
			alert('Load error.');
		  }
		});

		
	});
}

function youtube_popup(){
	$('.youtube_popup').on("click", function () {
		
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");  
		$.ajax({
		  url: url,
		  type:"json",
		  success:function(data) {
			$(".album_loading").fadeOut("fast");
			var photos = [];
				var obj = { 
					"src": data.youtube_share_link,
					"thumb": data.img_itemimage_thumb,
					//"poster":  data.img_itemimage_thumb
				};
				if (data.title){
					obj.subHtml= '<div class="photo_title">'+data.title+'</div>';
				}
				photos.push(obj);	
			$this.lightGallery({
				dynamic: true,
				dynamicEl: photos,
				speed: 300,
				hideBarsDelay: 1000,
				closable : false,
				loop: false,
				download: false,
				enableDrag : false,
				thumbWidth : 112,
				thumbContHeight : 83,
				thumbMargin : 10,
				toogleThumb : false,
				//youtubePlayerParams: {autoplay:0 },
				counter: false,
				videoMaxWidth: '900px',
				addClass: "youtubegallery_popup",
				fullScreen: false
			});
		  },
		  error: function(){
			$(".album_loading").fadeOut("fast");
			alert('Load error.');
		  }
		});

		
	});
}

function validate(){
	var options = {
		highlight: function(element, errorClass, validClass) {
			if ($(element).closest(".type_item").length){
				$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function(element, errorClass, validClass) {
			if ($(element).closest(".type_item").length){
				$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
			}
		}
	}
	if ($("#forms_form").length){
		$("#forms_form").validate(options);
		$("#forms_form select").change(function(){
			$(this).valid();
		});
	}
	if ($("#letter_form").length){ // Postform
		$("#letter_form").validate(options);
	}
	if ($("#poll_form").length){
		$("#poll_form").validate(options);
		$("#poll_form select").change(function(){
			$(this).valid();
		});
	}
	if ($("#subscription_form").length){
		$("#subscription_form").validate(options);
	}
	if ($("#poll_widget").length){
		$("#poll_widget").validate(options);
	}
	if ($("#sitelogin_widget").length){
		$("#sitelogin_widget").validate(options);
	}
	if ($("#duk_form").length){
		$("#duk_form").validate(options);
	}
	if ($(".comment-form").length){
		$(".comment-form").validate(options);
	}
	if ($("#sitelogin_form").length){
		$("#sitelogin_form").validate(options);
	}
	if ($("#adlogin_form").length){
		$("#adlogin_form").validate(options);
	}
	if ($("#faq_form").length){
		$("#faq_form").validate(options);
	}
	if ($("#subscription_form_index").length){
		$("#subscription_form_index").validate(options);
	}
}

function mobile_sidebar(){
	var $m = $("#mobile_menu").mmenu({
	 "extensions": [
		  "border-full",
		  "theme-white"
	   ],
	   "offCanvas": {
		  "zposition": "next",
	   },
	   "counters": false,
	   "slidingSubmenus" : false,
//	   "navbar": {
//			"title": " "
//		},
//	   "navbars": [
//		  {
//			 "position": "top",
//		  }
//	   ]
	}, {
		selectedClass: "active"
	});
	
	$(window).bind("pageshow", function(event) { 
		if (event.originalEvent.persisted) { //bugfix - iphone safari history state leaves menu open. Close it!
			setTimeout(function(){
				var API = $m.data( "mmenu" );
				API.close();
			}, 50);
		}
	});
	
}

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
 
function fixed_header(){
	$('.container-fluid').click(function() {
		$(".langs_drop_cont").slideUp("fast");
		$(".langs_cont").removeClass("dropped");
	});
	
	$(".current_lang_cont").click(function(e){
		e.stopPropagation(); 
		$(this).parent().toggleClass("dropped");
		$(this).parent().find(".langs_drop_cont").slideToggle("fast");
	});
	
	// Fixes the fixed header in iOS
	if(isMobile.iOS()) {
		var $body;
		if ('ontouchstart' in window) {
		  $body = $("body");
		  document.addEventListener('focusin', function() {
			return $body.addClass("fixfixed");
		  });
		  return document.addEventListener('focusout', function() {
			$body.removeClass("fixfixed");
			return setTimeout(function() {
			  return $(window).scrollLeft(0);
			}, 20);
		  });
		}
	}
	
}

// EU Cookie function start //
var eu_cookie_name = site_name_trimmed+'_ew4_eu_cookie';
function eu_cookie(){
	if (document.getElementById('cookie_block')){
		if ( !$.cookie(eu_cookie_name)){
			$('#cookie_block').hide().prependTo("body > .mm-page").delay(300).slideDown("fast");
		}
		$(".hide_cookie_msg").click(function(){
			$(this).parent().slideUp('fast');
		});
	}
}

function accept_eu_cookie(){
	$('#cookie_block').fadeOut(400);
	$.cookie(eu_cookie_name, 1,  { expires: 182, path: '/' });
}
// EU Cookie function end //

function print_v(){
	$(".print_button").click(function(){
		window.print();
	});
}

function highlight_search_results(){
	if ($('.search_results').length){
		var query = $('.search_results').data('text');
		$(".search_results").highlight(query);
	}
		
}

function file_input(){
	$("input[type=file]").nicefileinput({});
}

function mobile_overflow_tables(){
	if ($(".content_template").length){
		$('.content_template table').each(function() {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function() {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

function iframe_adaptability(){
	
	var $container = $( ".content_template" );
	var $iframes = $( "iframe" );
	
	$container.find($iframes).each(function () {
		$(this).wrap( "<div class='iframe_wrapper'></div>" );
	});
}

function getMoreInstagramPhotos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: true
	}).done(function(html) {
		$('.instagram_list').append(html);
		$('.loader_content').hide();
	});
}

function reportbug_form(){
	if ($("#reportbug_form_wrapper").length){
		$(".reportbug_link a").fancybox({
			type: "inline",
			padding: [55, 10, 30, 20],
			margin: [10, 0, 10, 0],
			afterClose: function () {
				$(".bugreport_form").find(".bugreport_form_infos").hide();
				$(".bugreport_form").find(".one_item").show();
				$(".bugreport_form").find(".reportbug_submit").show();
				$(".bugreport_form").find(".phpcaptcha_container").show();
			}
		});
		
		$(".bugreport_form").validate({
			submitHandler: function(form) {
			if ($(".bugreport_form").hasClass("currently_sending")){ // if btn inactive
				return false;
			}
			var data = $(form).serialize();
			var url = $(form).data("url");
			var $form = $(".bugreport_form");
			$form.addClass("currently_sending");
			$.ajax({
				type: "POST",
				url: url,
				data: data,
				success: function(data) {
					$form.removeClass("currently_sending");
					var $infoc = $(".bugreport_form_infos");
					$infoc.find(".info_cont").fadeOut("fast").html();
					$infoc.find(".error_cont").fadeOut("fast");
					$infoc.find(".error_cont .errors_list").html();
					if ($(".phpcaptcha_container", $form).length){
						var captchasrc = $form.find("#captcha_value_image").attr("src");
						$form.find("#captcha_value_image").attr("src", captchasrc.split("?")[0]+"?r="+Math.random());
					}
					if (!data.data.success) {
						$infoc.fadeIn("fast");
						$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						$(".fancybox-inner").animate({scrollTop: 0 + 'px'}, 'fast');
						
					} 
					else {
						$infoc.fadeIn("fast");
						$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
						$form.find("input").not("[name=SITEXSRF]").val('');
						$form.find("textarea").val('');
						$form.find(".one_item").fadeOut("fast");
						$form.find(".reportbug_submit").fadeOut("fast");
						$form.find(".phpcaptcha_container").fadeOut("fast");
					}	
				}
			});
				return false;
			}
		});
	}
}

function show_more(){
	$('.blocks_container').find('.show_more').click(function(){
		$(this).toggleClass('active');
		$(this).parent('.text_container').next('.block_more_info').slideToggle('fast').toggleClass('open');
	});
	
	$('.blocks_container').find('.show_less').click(function(){
		$(this).parents('.single_block').find('.show_more').removeClass('active');
		$(this).parent('.block_more_info').slideUp('fast').removeClass('open');
	});
	
	$('.videos_list').find('.show_video_desc').click(function(){
		$(this).toggleClass('active');
		$(this).next('.resource_video_desc').slideToggle('fast');
	});
}

function postformwidget_validate(){
	var $form = $("#postformwidget_form");
	if ($form.length){
		$form.validate({
			submitHandler: function(form) {
				if ($form.hasClass("currently_sending")){ 
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function(data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".postformwidget_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						} 
						else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").val('');
							$form.find("textarea").val('');
							$form.find(".input_holder").fadeOut("fast");
							$form.find(".contact_block_title").fadeOut("fast");
							$form.find(".recaptcha_cont").fadeOut("fast");
							$form.find(".button_holder").fadeOut("fast");
							setTimeout(function(){
								$(window).trigger('resize');
							}, 450);
						}	
					}
				});
					return false;
				}
		});
	}
}

function init_contacts(){
	if ($(".contacts_struct_cont").length){
		$('#search_by_field').change(function(){
			$('#search_by_label').text($("#search_by_field option[value='"+$(this).val()+"']").text());
		});
	}
}

function login_tabs(){
	$(".tab_header .header_btn").click(function(){
		var href = $(this).data("href");
		$(".tab_header .header_btn").removeClass("active");
		$(this).addClass("active");
		
		$(".tab_content").removeClass("active");
		$(href).addClass("active");
	});
}


